<div class="w-100">
    <div class="w-100 d-flex justify-content-between align-items-center px-1 gap-2 c-pointer">
        <div matRipple (click)="toggleMainNav()"
            class="flex-grow-1 flex-md-grow-0 px-3 py-2 rounded-2 zx-border-gray-v-light"
            [class.zx-border-green]="isDarkMode">
            <div class="d-flex align-items-center w-100" *ngIf="isLoading">
                <mat-spinner class="zx-small-icon-size"></mat-spinner>
            </div>
            <div class="d-flex align-items-center gap-2" *ngIf="!isLoading">
                <img [src]="'assets/images/' + getPrintingService(myPrintingServicesList[0]) + '-icon.svg'"
                    alt="choosen printing system icon" class="zx-small-icon-size">
                <img [src]="'assets/images/branches/' + myBranchesList[0] + '.png'" alt="choosen printing system icon"
                    class="zx-small-icon-size c-pointer">
                <div class="d-flex align-items-center">
                    <span class="zx-text-small zx-100-opp">,</span>
                    <span class="zx-text-small d-sm-none" [class.text-white]="isDarkMode">
                        <span>
                            {{ 'choose-branch.naming.' + myPrintingServicesList[0] + "." + myBranchesList[0] | translate
                            }}
                        </span>
                    </span>
                    <span class="zx-text-small d-none d-sm-inline">
                        {{ 'choose-branch.naming.' + myPrintingServicesList[0] + "." + myBranchesList[0] | translate }}
                    </span>
                </div>
                <span class="spacer d-md-none"></span>
                <img *ngIf="!isDarkMode" src="/assets/images/tiny-arrow-icon.svg"
                    class="svg zx-tiny-icon-size c-pointer">
                <img *ngIf="isDarkMode" src="/assets/images/tiny-arrow-icon-green.svg"
                    class="svg zx-tiny-icon-size c-pointer">
            </div>
        </div>
        <div class="p-1 rounded-2 d-flex justify-content-center align-items-center gap-1 gap-lg-3">
            <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="goToPrintingTable()"
                class="close-icon d-flex align-items-center justify-content-center" [class.zx-text-white]="isDarkMode"
                [matTooltip]="'q-and-a.1.btn-try-print' | translate" [matTooltipPosition]="'below'">
                <mat-icon>keyboard_arrow_left</mat-icon>
            </button>
        </div>
    </div>
    <div *ngIf="isNavOpen" class="position-relative d-flex w-100">
        <div class="d-flex position-absolute zx-top-2-px start-0 zx-z-index-2" [class.end-0]="isRTL">
            <div class="d-flex flex-column w-100 p-2 mx-1 rounded-2 bg-white d-flex shadow-85-strong zx-navigation-from-printer-manigment-width"
                [class.zx-bg-dark]=" isDarkMode" [class.zx-border-gray-v-light]="!isDarkMode">

                <!-- OPTIONS -->
                <div *ngIf="isLoading" class="w-100 d-flex justify-content-center align-items-center"
                    style="height: 160px;">
                    <mat-spinner class="zx-small-icon-size"></mat-spinner>
                </div>

                <div class="w-100 zx-navigation-from-printer-manigment-height" *ngIf="!isLoading">
                    <div class="d-flex row align-items-center p-0" *ngFor="let cl of clusters; let i = index"
                        [class.zx-border-gray-top-v-v-light]="i !== 0"
                        [class.zx-border-top-gray-25-pr]="i !== 0 && isDarkMode">
                        <b class="d-flex col-3 zx-text-tiny zx-text-sm-small">
                            {{ "choose-branch.naming." + cl.serial_name | translate }}
                        </b>
                        <div class="d-flex align-items-center col-9 row p-0">
                            <div *ngFor="let printer of cl.plotter"
                                class="d-flex flex-column align-items-center gap-1 px-1 py-2 step-item-hover col-4 rounded-2"
                                (click)="chaingePrintingServiceAndBranch('plotter', printer.serial_name)" matRipple>
                                <span class="text-center zx-text-tiny-tiny zx-text-sm-tiny">
                                    {{ ("choose-branch.naming.plotter." + printer.serial_name | translate) | slice:0:12
                                    }}
                                </span>
                                <img [src]="'assets/images/plotter-icon.svg'" alt="plotter"
                                    class="zx-small-icon-size zx-small-small-plus-icon-size-lg c-pointer">
                            </div>
                            <div *ngFor="let printer of cl.express"
                                class="d-flex flex-column align-items-center gap-1 px-1 py-2 step-item-hover col-4 rounded-2"
                                (click)="chaingePrintingServiceAndBranch('express', printer.serial_name)" matRipple>
                                <span class="text-center zx-text-tiny-tiny zx-text-sm-tiny">
                                    {{ ("choose-branch.naming.express." + printer.serial_name | translate) | slice:0:12
                                    }}
                                </span>
                                <img [src]="'assets/images/' + getIsPics(printer) + '-icon.svg'" alt="express"
                                    class="zx-small-icon-size zx-small-small-plus-icon-size-lg c-pointer">
                            </div>
                        </div>
                    </div>
                    <div style="height: 10px;"></div>
                </div>
                <!-- // OPTIONS -->

            </div>
        </div>
    </div>
    <div class="w-100 opacity-50 mt-3">
        <hr class="m-0">
    </div>
</div>